import React from 'react'

const NoRecordsProvider = ({ height }) => {
    return (
        <div className="d-flex flex-column align-items-center box-wrapper justify-content-center gap-3" style={{ minHeight: height || '300px' }} >
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0zM12 15.75h.007v.008H12z" /></svg>
            <p>Currently, there are no service providers for this service. Please come back soon for updates!</p>
        </div>
    )
}

export default NoRecordsProvider
